var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullBlurNoUserButton001(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 99 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f5f5f5;}.b{fill:#d7d7d7;}.c{fill:#e0e0e0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -918.461975, -234.169998)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.264 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M84,1H80V-1h4ZM74,1H70V-1h4ZM64,1H60V-1h4ZM54,1H50V-1h4ZM44,1H40V-1h4ZM34,1H30V-1h4ZM24,1H20V-1h4ZM14,1H10V-1h4ZM4,1H0V-1H4Z",
    transform: "translate(938.558 262.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74,1H70V-1h4ZM64,1H60V-1h4ZM54,1H50V-1h4ZM44,1H40V-1h4ZM34,1H30V-1h4ZM24,1H20V-1h4ZM14,1H10V-1h4ZM4,1H0V-1H4Z",
    transform: "translate(943.613 268.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74,1H70V-1h4ZM64,1H60V-1h4ZM54,1H50V-1h4ZM44,1H40V-1h4ZM34,1H30V-1h4ZM24,1H20V-1h4ZM14,1H10V-1h4ZM4,1H0V-1H4Z",
    transform: "translate(942.114 256.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M64,1H60V-1h4ZM54,1H50V-1h4ZM44,1H40V-1h4ZM34,1H30V-1h4ZM24,1H20V-1h4ZM14,1H10V-1h4ZM4,1H0V-1H4Z",
    transform: "translate(948.726 274.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M64,1H60V-1h4ZM54,1H50V-1h4ZM44,1H40V-1h4ZM34,1H30V-1h4ZM24,1H20V-1h4ZM14,1H10V-1h4ZM4,1H0V-1H4Z",
    transform: "translate(948.226 250.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M44,1H40V-1h4ZM34,1H30V-1h4ZM24,1H20V-1h4ZM14,1H10V-1h4ZM4,1H0V-1H4Z",
    transform: "translate(958.334 280.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M44,1H40V-1h4ZM34,1H30V-1h4ZM24,1H20V-1h4ZM14,1H10V-1h4ZM4,1H0V-1H4Z",
    transform: "translate(958.334 244.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24,1H20V-1h4ZM14,1H10V-1h4ZM4,1H0V-1H4Z",
    transform: "translate(968.456 286.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24,1H20V-1h4ZM14,1H10V-1h4ZM4,1H0V-1H4Z",
    transform: "translate(968.578 238.67)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullBlurNoUserButton001);
export default __webpack_public_path__ + "full-blur-no-user-button-001.5ccf981e669b8a5f8c75f4e47dddf1d6.svg";
export { ForwardRef as ReactComponent };